var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImprimir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.66 17.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.41,0H4.25c-.14,0-.26.12-.26.26v5.08c0,.14.12.26.26.26s.26-.12.26-.26V.52h8.64v4.81c0,.14.12.26.26.26s.26-.12.26-.26V.26c0-.14-.12-.26-.26-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.38,11.71h.36c.14,0,.26-.12.26-.26s-.12-.26-.26-.26H3.92c-.14,0-.26.12-.26.26s.12.26.26.26h.36l-.44,4.11c-.02.14.09.27.23.29.14.02.27-.09.29-.23l.45-4.16h8.05l.58,5.37H4.23l.04-.33c.02-.14-.09-.27-.23-.29-.14-.02-.27.09-.29.23l-.07.62c0,.07.02.15.07.2.05.06.12.09.2.09h9.79c.07,0,.15-.03.2-.09.05-.06.07-.13.07-.2l-.6-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.53,5.9H1.71c-.94,0-1.71.77-1.71,1.71v5.85c0,.94.77,1.71,1.71,1.71h1.61c.14,0,.26-.12.26-.26s-.12-.26-.26-.26h-1.61c-.65,0-1.18-.53-1.18-1.18v-5.85c0-.65.53-1.18,1.18-1.18h12.82c.14,0,.26-.12.26-.26s-.12-.26-.26-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.95,5.9h-.55c-.14,0-.26.12-.26.26s.12.26.26.26h.55c.65,0,1.18.53,1.18,1.18v5.85c0,.65-.53,1.18-1.18,1.18h-1.61c-.14,0-.26.12-.26.26s.12.26.26.26h1.61c.94,0,1.71-.77,1.71-1.71v-5.85c0-.94-.77-1.71-1.71-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.56,9.95H3.09c-.14,0-.26.12-.26.26v2.8c0,.14.12.26.26.26h.43c.14,0,.26-.12.26-.26s-.12-.26-.26-.26h-.17v-2.27h10.94v2.27h-.17c-.14,0-.26.12-.26.26s.12.26.26.26h.43c.14,0,.26-.12.26-.26v-2.8c0-.14-.12-.26-.26-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.26,6.98c-.65,0-1.17.53-1.17,1.17s.53,1.17,1.17,1.17,1.17-.53,1.17-1.17-.53-1.17-1.17-1.17ZM2.26,8.8c-.36,0-.65-.29-.65-.65s.29-.65.65-.65.65.29.65.65-.29.65-.65.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.98,6.98c-.65,0-1.17.53-1.17,1.17s.53,1.17,1.17,1.17,1.17-.53,1.17-1.17c0-.65-.53-1.17-1.17-1.17ZM4.98,8.8c-.36,0-.65-.29-.65-.65s.29-.65.65-.65.65.29.65.65-.29.65-.65.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.24,15.55h-6.82c-.14,0-.26.12-.26.26s.12.26.26.26h6.82c.14,0,.26-.12.26-.26s-.12-.26-.26-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.07,14.36h-6.49c-.14,0-.26.12-.26.26s.12.26.26.26h6.49c.14,0,.26-.12.26-.26s-.12-.26-.26-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.93,13.17h-6.21c-.14,0-.26.12-.26.26s.12.26.26.26h6.21c.14,0,.26-.12.26-.26s-.12-.26-.26-.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprimir);
export default __webpack_public_path__ + "static/media/Imprimir.3c545070bdbb068cd73eaec8638de5d1.svg";
export { ForwardRef as ReactComponent };